import * as types from './actionTypes'
import * as firebaseNetwork from '../API/FirebaseManager'
import * as network from '../API/NetworkRequests'



export function getUserDataForCurrentCompanySuccess(userData) {
    return { type: types.GET_USER_DATA_SUCCESS, payload: userData }
}

export function setManagerForUserSuccess(managerUID) {
    return { type: types.SET_MANAGER_FOR_USER, payload: managerUID }
}

export function setRegionForUserSuccess(region) {
    return { type: types.SET_REGION_FOR_USER, payload: region }
}

export function updateUserSuccess(userObejct) {
    return { type: types.UPDATE_USER_SUCCESS, payload: userObejct }
}









export function getUserDataForCurrentCompany(userUID, companyID) {
    return function(dispatch, getState){
        const { companies } = getState();
        return firebaseNetwork.getEndUserInfoWith(userUID, companyID).then(userData => {
            dispatch(getUserDataForCurrentCompanySuccess(userData))
        }).catch(error => {
            throw error
        })
    }
}

export function setManagerForUser(managerUID) {
    return function(dispatch, getState){
        const { companies, currentUser } = getState();
        let tempUser = currentUser
        tempUser.managerUID = managerUID
        return network.updateUser(tempUser, null, companies.currentCompany.companyID).then(value => {
            dispatch(setManagerForUserSuccess(managerUID))
        }).catch(error => {
            throw error
        })
    }
}

export function setRegionForUser(region) {
    return function(dispatch, getState){
        const { companies, currentUser } = getState();
        let tempUser = currentUser
        tempUser.region = region
        return network.updateUser(tempUser, null, companies.currentCompany.companyID).then(value => {
            dispatch(setRegionForUserSuccess(region))
        }).catch(error => {
            throw error
        })
    }
}

export function updateUserInfo(userObejct) {
    return function(dispatch, getState){
        const { companies } = getState();
        return network.updateUser(userObejct, userObejct.password, companies.currentCompany.companyID).then(value => {
            dispatch(updateUserSuccess(userObejct))
        }).catch(error => {
            throw error
        })
    }
}


// WEBPACK FOOTER //
// ./src/actions/userActions.js